import { useState } from "react";

interface ShareButtonProps {
  title: string;
}

const shareOptions = [
  { icon: "ri-link", label: "复制链接", key: "copy" },
  { icon: "ri-wechat-line", label: "微信", key: "wechat" },
  { icon: "ri-weibo-line", label: "微博", key: "weibo" },
  { icon: "ri-qq-line", label: "QQ", key: "qq" },
  { icon: "ri-twitter-x-line", label: "X", key: "x" },
];

export default function ShareButton({ title }: ShareButtonProps) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleClick = async (key: string) => {
    if (key === "copy") {
      try {
        await navigator.clipboard.writeText(window.location.href);
      } catch {
        // clipboard may be unavailable in some environments
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
      return;
    }
    setCopied(false);
    setOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground-950/40 px-4">
          <div className="w-full max-w-sm rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">分享到</h3>
                <p className="mt-1 line-clamp-2 text-xs text-foreground-500">{title}</p>
              </div>
              <button
                type="button"
                aria-label="关闭"
                onClick={() => setOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900 cursor-pointer"
              >
                <i className="ri-close-line" />
              </button>
            </div>

            <div className="mt-5 grid grid-cols-5 gap-2">
              {shareOptions.map((opt) => (
                <button
                  key={opt.key}
                  type="button"
                  onClick={() => handleClick(opt.key)}
                  className="flex flex-col items-center gap-2 rounded-md px-1 py-2 transition-colors hover:bg-background-100 cursor-pointer"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className={`${opt.icon} text-lg`} />
                  </span>
                  <span className="text-[11px] text-foreground-600">{opt.label}</span>
                </button>
              ))}
            </div>

            <p className="mt-4 rounded-md bg-background-100 px-3 py-2 text-center text-xs text-accent-700">
              {copied ? "链接已复制到剪贴板" : "分享功能为前端演示，不会真正发布到第三方平台"}
            </p>
          </div>
        </div>
      )}
    </>
  );
}